import React, { Component } from 'react';
import './../css/master.css';
import './../css/weaver.css';
import WeaverHeader from './../js/weaverHeader.js';
import axiosInstance from '../api/wvrAxios';
import $ from 'jquery';
import DatePicker from 'react-datepicker';
//import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReactImageMagnify from 'react-image-magnify';
const { IMG_TYPES } = require('./imgType');

var httpURL = '';
var sortVal = "";
var queryString = require('querystring');
var lstQuotes = [];
var lstQuoteDesigns = [];
var lstMachineType = [];
var lstConstruction = [];
var lstYarnCount = [];
var lstWidth = [];
var lstQuality = [];
var COL_QT_QUOTEID = 'td:eq(0)';
var COL_QT_DESIGNID = 'td:eq(1)';
var COL_QT_DESIGNCOLOR = 'td:eq(2)';
var COL_QT_RECEIVED = 'td:eq(3)';
var COL_QT_RESPONSE = 'td:eq(4)';
var COL_QT_STATUS = 'td:eq(5)';
var COL_QDT_DESIGNID = 'td:eq(0)';
var COL_QDT_DESIGNCOLOR = 'td:eq(1)';
var COL_QDT_IMG = 'td:eq(2)';
var COL_QDT_RECIEVEDON = 'td:eq(3)';
var COL_QDT_RESPONSEON = 'td:eq(4)';
var COL_QDT_STATUS = 'td:eq(5)';
var COL_QDT_CONSTRUCTION = 'td:eq(6)';
var COL_QDT_YARNCOUNT = 'td:eq(7)';
var COL_QDT_QUALITY = 'td:eq(8)';
var COL_QDT_LENGTH = 'td:eq(9)';
var COL_QDT_WIDTH = 'td:eq(10)';

class Weaver extends Component {
	constructor(props) {
		super(props);
		this.state = {
			quotes: [],
			quoteDesign: [],
			machineType: [],
			
			startDate: null,
			endDate: null,
			width: '97.6%',
			width1: '97.6%',
			src: require('./../images/blank.png'),
		}
	}

	async componentDidMount() {
		this.handleResize();
		window.addEventListener("load", this.handleResize);
		window.addEventListener("resize", this.handleResize);

		await axiosInstance.get(httpURL + '/a/mst/cons/list', {
			withCredentials: true
		}).then((response) => {
			if (response.data.SvcStatus === 'Success') {
				lstConstruction = response.data.lstConstruction;
				this.fillConstructionCmb();
			}
			else {
				toast.error(response.data.SvcMsg);
			}
		}).catch((error) => {
			toast.error("Service failed " + error);
		});

		await axiosInstance.get(httpURL + '/a/mst/yarn/list', {
			withCredentials: true
		}).then((response) => {
			if (response.data.SvcStatus === 'Success') {
				lstYarnCount = response.data.lstYarnCount;
				this.fillYarnCountCmb();
			}
			else {
				toast.error(response.data.SvcMsg);
			}
			this.setState({ loader: 'none', opacity: 1 });
		}).catch((error) => {
			toast.error("Service failed " + error);
		});

		await axiosInstance.get(httpURL + '/a/mst/wdh/list', {
			withCredentials: true
		}).then((response) => {
			if (response.data.SvcStatus === 'Success') {
				lstWidth = response.data.lstWidth;
				this.fillWidthCmb();
			}
			else {
				toast.error(response.data.SvcMsg);
			}
			this.setState({ loader: 'none', opacity: 1 });
		}).catch((error) => {
			toast.error("Service failed " + error);
		});

		await axiosInstance.get(httpURL + '/a/mst/qlty/list', {
			withCredentials: true
		}).then((response) => {
			if (response.data.SvcStatus === 'Success') {
				lstQuality = response.data.lstQuality;
				this.fillQualityCmb();
			}
			else {
				toast.error(response.data.SvcMsg);
			}
			this.setState({ loader: 'none', opacity: 1 });
		}).catch((error) => {
			toast.error("Service failed " + error);
		});

		var endDate = new Date();
		await this.setState({
			endDate: new Date(endDate),
		});
		var startDate = endDate.setDate(endDate.getDate() - 60);
		await this.setState({
			startDate: new Date(startDate),
		});
		this.getQuote();
	}

	handleResize = () => {
		var width = ($('.tableLayout1').parent().width()) - 18;
		var width1 = ($('.tableLayout2').parent().width()) - 18;
		this.setState({ width: width, width1: width1 })
	}

	fillConstructionCmb() {
		$('#inp_construction').empty();
		$('#inp_construction').prepend($("<option> </option>").val(0).html('Construction'));
		for (var i = 0; i < lstConstruction.length; i++) {
			var constructionId = lstConstruction[i].constructionId;
			var construction = lstConstruction[i].construction;
			$('#inp_construction').append($("<option> </option>").val(constructionId).html(construction));
		}
	}

	fillYarnCountCmb() {
		$('#inp_yarnCount').empty();
		$('#inp_yarnCount').prepend($("<option> </option>").val(0).html('Yarn Count'));
		for (var i = 0; i < lstYarnCount.length; i++) {
			var yarnCountId = lstYarnCount[i].yarnCountId;
			var yarnCount = lstYarnCount[i].yarnCount;
			$('#inp_yarnCount').append($("<option> </option>").val(yarnCountId).html(yarnCount));
		}
	}

	fillWidthCmb() {
		$('#inp_width').empty();
		$('#inp_width').prepend($("<option> </option>").val(0).html('Width'));
		for (var i = 0; i < lstWidth.length; i++) {
			var widthId = lstWidth[i].widthId;
			var width = lstWidth[i].width;
			$('#inp_width').append($("<option> </option>").val(widthId).html(width));
		}
	}

	fillQualityCmb() {
		$('#inp_quality').empty();
		$('#inp_quality').prepend($("<option> </option>").val(0).html('Quality Name'));
		for (var i = 0; i < lstQuality.length; i++) {
			var qualityId = lstQuality[i].qualityId;
			var quality = lstQuality[i].quality;
			$('#inp_quality').append($("<option> </option>").val(qualityId).html(quality));
		}
	}

	getQuote = () => {
		var weaverId = sessionStorage.getItem('weaverId');
		var fromDt = $('#inp_fromDate').val();
		var toDt = $('#inp_toDate').val();
		var weaver = { 'weaverId': weaverId, 'fromDate': fromDt, 'toDate': toDt }
		axiosInstance.post(httpURL + '/w/q/list',
			queryString.stringify({ 'Wvr': JSON.stringify(weaver) }), { withCredentials: true }
		).then((response) => {
			if (response.data.SvcStatus === 'Success') {
				this.setState({
					quotes: response.data.lstQuotes,
				})
				lstQuotes = this.state.quotes;
				this.setQuotesTable();
			}
			else {
				toast.error(response.data.SvcMsg);
				if (response.data.SvcMsg == 'You are not logged in') {
					window.location.href = window.WVRURL;
					return false;
				}
			}
		}).catch((error) => {
			toast.error("Service failed " + error);
		});
	}

	setQuotesTable = () => {
		$('#quoteTableBody tr').remove();
		var table = document.getElementById('quoteTable');
		var tbody = document.getElementById('quoteTableBody');
		var filterDesignColor = $('#filterDesignColor').val().trim().toLowerCase();

		for (var i = 0; i < lstQuotes.length; i++) {
			var quoteId = lstQuotes[i].quoteId;
			var designId = lstQuotes[i].designId;
			var designNoColor = lstQuotes[i].designNoColor;
			var recievedOn = lstQuotes[i].recievedOn;
			var responseOn = lstQuotes[i].responseOn;
			responseOn = responseOn == '' || responseOn == null ? '-' : responseOn;
			var status = lstQuotes[i].quoteStatus;

			var row = document.createElement('tr');
			row.id = 'quoteTable' + quoteId;
			row.onclick = (e) => {
				$(e.target).closest('tr').addClass('selected').siblings().removeClass('selected');
				$('.cd-panel').addClass('is-visible');
				$('.main').addClass('addOpacity');
				this.setSlider();
				$('.designPopup1').css("display", "block");
				this.handleResize();
			}

			if (designNoColor.toLowerCase().indexOf(filterDesignColor) === -1)
				continue;

			this.addTD(row, quoteId, 'text-right');
			this.addTD(row, designId, 'text-right');
			this.addTD(row, designNoColor, '');
			this.addTD(row, recievedOn, 'text-center');
			this.addTD(row, responseOn, 'text-center');
			this.addTD(row, status, '');

			tbody.append(row);
		}
		table.append(tbody);
	}

	setSlider = () => {
		var quoteId = $('#quoteTableBody tr.selected').find(COL_QT_QUOTEID).text();
		var weaverId = sessionStorage.getItem('weaverId');

		$('#wvrQuoteDesignForm').trigger('reset');
		$('#inp_quoteId').val(quoteId);
		axiosInstance.post(httpURL + '/w/q/dtls',
			queryString.stringify({ 'quoteId': quoteId, 'weaverId': weaverId }), { withCredentials: true }
		).then((response) => {
			if (response.data.SvcStatus === "Success") {
				this.setState({
					quoteDesign: response.data.lstQuotesDtls,
					machineType: response.data.lstMachineType,
					src: require('./../images/blank.png'),
				})
				lstQuoteDesigns = this.state.quoteDesign;
				lstMachineType = this.state.machineType;
				this.fillMachineCmb();
				this.setQuoteDesignTable();
			}
			else {
				toast.error(response.data.SvcMsg);
			}
		}).catch((e) => {
			toast.error("Service failed " + e);
		});
	}

	fillMachineCmb() {
		$('#inp_machineCmb').empty();
		$('#inp_machineCmb').prepend($("<option> </option>").val(0).html('Select'));
		for (var i = 0; i < lstMachineType.length; i++) {
			var machineTypeId = lstMachineType[i].machineTypeId;
			var machineType = lstMachineType[i].machineType;
			$('#inp_machineCmb').append($("<option> </option>").val(machineTypeId).html(machineType));
		}
	}

	setQuoteDesignTable = () => {
		$('#quoteDesignTableBody tr').remove();

		var table = document.getElementById('quoteDesignTable');
		var tbody = document.getElementById('quoteDesignTableBody');

		for (var i = 0; i < lstQuoteDesigns.length; i++) {
			var designId = lstQuoteDesigns[i].designId;
			var designNoColor = lstQuoteDesigns[i].designNoColor;
			var designImage = lstQuoteDesigns[i].img;
			var recievedOn = lstQuoteDesigns[i].recievedOn;
			var responseOn = lstQuoteDesigns[i].responseOn;
			responseOn = responseOn == '' || responseOn == null ? '-' : responseOn;
			var status = lstQuoteDesigns[i].quoteStatus;
			var csConstruction = lstQuoteDesigns[i].csConstruction;
			var csYarnCount = lstQuoteDesigns[i].csYarnCount;
			var csQuality = lstQuoteDesigns[i].csQuality;
			var csLength = lstQuoteDesigns[i].csLength == 0 ? '' : lstQuoteDesigns[i].csLength;
			var csWidth = lstQuoteDesigns[i].csWidth == 0 ? '' : lstQuoteDesigns[i].csWidth;

			var row = document.createElement('tr');

			row.onclick = (e) => {
				$(e.target).closest('tr').addClass('selected').siblings().removeClass('selected');
				var designId = $(e.target).closest('tr.selected').find('td:eq(0)').text();
				var statusFind = $(e.target).closest('tr.selected').find(COL_QDT_STATUS).text();
				this.setDesignForm(designId, statusFind);

			}

			this.addTD(row, designId, 'text-right');
			this.addTD(row, designNoColor, '');
			this.addTDImage(row, designImage, 'text-center');
			this.addTD(row, recievedOn, 'text-center');
			this.addTD(row, responseOn, 'text-center');
			this.addTD(row, status, '');
			this.addTD(row, csConstruction, '');
			this.addTD(row, csYarnCount, '');
			this.addTD(row, csQuality, '');
			this.addTD(row, csLength, 'text-right');
			this.addTD(row, csWidth, '');

			tbody.append(row);
		}
		table.append(tbody);
	}

	setDesignForm = (designId, statusFind) => {

		if (statusFind == 'ACCEPTED') {
			$('#wvrQuoteDesignForm input').attr('disabled', true);
			$('#wvrQuoteDesignForm select').attr('disabled', true);
			$('#wvrQuoteDesignForm select').css('backgroundColor', '#eeeeee');
			$("#update_po").prop("disabled", true);
		} else {
			$('#wvrQuoteDesignForm input').attr('disabled', false);
			$('#wvrQuoteDesignForm select').attr('disabled', false);
			$('#wvrQuoteDesignForm select').css('backgroundColor', '#fff');
			$("#update_po").prop("disabled", false);
		}

		var getQuoteDesignData = this.getgetQuoteDesignDtls(designId);
		if (getQuoteDesignData != -1) {
			$('#inp_machineCmb').val(getQuoteDesignData.wvrMachineTypeId);
			$('#inp_construction').val(getQuoteDesignData.wvrConstructionId);
			$('#inp_width').val(getQuoteDesignData.wvrWidthId);
			$('#inp_quality').val(getQuoteDesignData.wvrQualityId);
			$('#inp_yarnCount').val(getQuoteDesignData.wvrYarnCountId);
			$('#inp_rate').val(getQuoteDesignData.wvrRate == 0 ? '' : getQuoteDesignData.wvrRate);
			$('#inp_moq').val(getQuoteDesignData.wvrMoq == 0 ? '' : getQuoteDesignData.wvrMoq);
			$('#inp_mor').val(getQuoteDesignData.wvrMor == 0 ? '' : getQuoteDesignData.wvrMor);
			$('#inp_notes').val(getQuoteDesignData.notes);

			if (getQuoteDesignData.img == '') {
				this.setState({ src: require('./../images/blank.png') });
			} else if (getQuoteDesignData.img != null) {
				var imageUrl = window.httpURL + "/a/mst/dsn/getImage?img=" + getQuoteDesignData.img + '&imgType=' + IMG_TYPES.DSN;
				this.setState({ src: imageUrl });
			} else {
				this.setState({ src: require('./../images/blank.png') });
			}
		}
	}

	getgetQuoteDesignDtls = (designId) => {
		for (var i = 0; i < lstQuoteDesigns.length; i++) {
			if (designId == lstQuoteDesigns[i].designId) {
				return lstQuoteDesigns[i];
			}
		}
		return -1;
	}

	hideSlider(e) {
		e.preventDefault();
		$('.cd-panel').removeClass('is-visible');
		$('.main').removeClass('addOpacity');
		$('.designPopup1').hide();
	}

	addTD(row, val, classname) {
		var cell = document.createElement('td');
		cell.className = classname;
		var text = document.createTextNode(val);
		cell.append(text);
		row.append(cell);
	}

	addTDImage(row, val, classname) {
		var date = new Date();
		var cell = document.createElement('td');
		cell.className = classname;
		var img = document.createElement('img');
		img.style.width = '20px';
		img.style.height = '20px';
		if (val == '') {
			img.src = require("../images/logo.png");
		} else if (val != null) {
			img.src = window.httpURL + "/a/mst/dsn/getImage?img=" + val + '&imgType=' + IMG_TYPES.THUMB;
		} else {
			img.src = require("../images/logo.png");
		}
		cell.append(img);
		row.append(cell);
	}

	update = () => {
		var designId = $('#quoteDesignTableBody tr.selected').find('td:eq(0)').text();
		var quoteId = $('#inp_quoteId').val();
		var weaverId = sessionStorage.getItem('weaverId');
		var wvrMachineTypeId = $('#inp_machineCmb').find('option:selected').val();
		var wvrConstructionId = $('#inp_construction').find('option:selected').val();
		var wvrWidthId = $('#inp_width').find('option:selected').val();
		var wvrQualityId = $('#inp_quality').find('option:selected').val();
		var wvrYarnCountId = $('#inp_yarnCount').find('option:selected').val();
		var wvrRate = $('#inp_rate').val();
		wvrRate = wvrRate == '' ? 0 : wvrRate;
		var wvrMoq = $('#inp_moq').val();
		wvrMoq = wvrMoq == '' ? 0 : wvrMoq;
		var wvrMor = $('#inp_mor').val();
		wvrMor = wvrMor == '' ? 0 : wvrMor;
		var notes = $('#inp_notes').val();
		if (designId == '') {
			toast.warning('Please select one design to update');
			return false;
		}
		if (wvrMachineTypeId == 0) {
			toast.warning('Please select machine');
			$('#inp_machineCmb').focus();
			return false;
		}
		if (wvrConstructionId == 0) {
			toast.warning('Please select construction');
			$('#inp_construction').focus();
			return false;
		}
		if (wvrQualityId == 0) {
			toast.warning('Please select quality');
			$('#inp_quality').focus();
			return false;
		}
		if (wvrYarnCountId == 0) {
			toast.warning('Please select yarn count');
			$('#inp_yarnCount').focus();
			return false;
		}
		if (wvrRate == 0 && (wvrMoq == 0 || wvrMor == 0)) {
			toast.warning('Please fill rate or minimum of quantity and rate');
			$('#inp_rate').focus();
			return false;
		}

		var wvrDtls = { weaverId, quoteId, designId, wvrMachineTypeId, wvrConstructionId, wvrWidthId, wvrQualityId, wvrYarnCountId, wvrRate, wvrMoq, wvrMor, notes };
		axiosInstance.post(httpURL + '/w/q/update',
			queryString.stringify({ 'Wvr': JSON.stringify(wvrDtls) }), { withCredentials: true }
		).then((response) => {
			if (response.data.SvcStatus === "Success") {
				toast.success(response.data.SvcMsg);
				var designIdx = this.getIdxDesign(designId);
				var qdesignIdx = this.getIdxQuoteDesign(quoteId, designId);
				var statusId = response.data.quoteStatusId;
				var status = response.data.quoteStatus;
				var respondOn = response.data.respondOn;
				if (designIdx != -1) {
					lstQuoteDesigns[designIdx].wvrMachineTypeId = wvrMachineTypeId;
					lstQuoteDesigns[designIdx].wvrConstructionId = wvrConstructionId;
					lstQuoteDesigns[designIdx].wvrWidthId = wvrWidthId;
					lstQuoteDesigns[designIdx].wvrQualityId = wvrQualityId;
					lstQuoteDesigns[designIdx].wvrYarnCountId = wvrYarnCountId;
					lstQuoteDesigns[designIdx].wvrRate = wvrRate;
					lstQuoteDesigns[designIdx].wvrMoq = wvrMoq;
					lstQuoteDesigns[designIdx].wvrMor = wvrMor;
					lstQuoteDesigns[designIdx].quoteStatusId = statusId;
					lstQuoteDesigns[designIdx].quoteStatus = status;
					lstQuoteDesigns[designIdx].responseOn = respondOn;
					this.setQuoteDesignTable();
					this.highlightRow('quoteDesignTableBody', designId);
				}
				if (qdesignIdx != -1) {
					lstQuotes[qdesignIdx].quoteStatusId = statusId;
					lstQuotes[qdesignIdx].quoteStatus = status;
					lstQuotes[qdesignIdx].responseOn = respondOn;
					this.setQuotesTable();
					this.highlightRow1('quoteTableBody', quoteId, designId);
				}
			}
			else {
				toast.error(response.data.SvcMsg);
			}
		}).catch((e) => {
			toast.error("Service failed " + e);
		});
	}

	getIdxDesign(designId) {
		for (var i = 0; i < lstQuoteDesigns.length; i++) {
			if (lstQuoteDesigns[i].designId == designId) {
				return i;
			}
		}
		return -1;
	}

	getIdxQuoteDesign(qId, dId) {
		for (var i = 0; i < lstQuotes.length; i++) {
			if (lstQuotes[i].quoteId == qId && lstQuotes[i].designId == dId) {
				return i;
			}
		}
		return -1;
	}

	highlightRow(table, id) {
		$('#' + table + ' tr').each(function () {
			var designId = $(this).find('td:eq(0)').text();
			if (designId == id) {
				$(this).addClass('selected').siblings().removeClass('selected');
			}
		});
	}

	highlightRow1(table, qId, dId) {
		$('#' + table + ' tr').each(function () {
			var quoteId = $(this).find(COL_QT_QUOTEID).text();
			var designId = $(this).find(COL_QT_DESIGNID).text();
			if (quoteId == qId && designId == dId) {
				$(this).addClass('selected').siblings().removeClass('selected');
			}
		});
	}

	sortAscByRecieved = () => {
		if (sortVal != 'asrec') {
			sortVal = 'asrec';
			$("#recievedAsDtIcon").css("color", "gray");
			$("#recievedDsDtIcon").css("color", "#111");
			$("#responseAsDtIcon").css("color", "#111");
			$("#responseDsDtIcon").css("color", "#111");

			var val1;
			var val2;

			for (var i = 0; i < lstQuotes.length - 1; i++) {
				val1 = lstQuotes[i].recievedOn;
				for (var j = i + 1; j < lstQuotes.length; j++) {
					val2 = lstQuotes[j].recievedOn;
					if (val1 > val2) {
						var tmp = lstQuotes[j];
						lstQuotes[j] = lstQuotes[i];
						lstQuotes[i] = tmp;
						val1 = lstQuotes[i].recievedOn;
					}
				}
			}
			this.setQuotesTable();
		}
	}

	sortDesByRecieved = () => {
		if (sortVal != 'dsrec') {
			sortVal = 'dsrec';
			$("#recievedAsDtIcon").css("color", "#111");
			$("#recievedDsDtIcon").css("color", "gray");
			$("#responseAsDtIcon").css("color", "#111");
			$("#responseDsDtIcon").css("color", "#111");

			var val1;
			var val2;

			for (var i = 0; i < lstQuotes.length - 1; i++) {
				val1 = lstQuotes[i].recievedOn;
				for (var j = i + 1; j < lstQuotes.length; j++) {
					val2 = lstQuotes[j].recievedOn;
					if (val1 < val2) {
						var tmp = lstQuotes[j];
						lstQuotes[j] = lstQuotes[i];
						lstQuotes[i] = tmp;
						val1 = lstQuotes[i].recievedOn;
					}
				}
			}
			this.setQuotesTable();
		}
	}

	sortAscByResponse = () => {
		if (sortVal != 'asres') {
			sortVal = 'asres';
			$("#recievedAsDtIcon").css("color", "#111");
			$("#recievedDsDtIcon").css("color", "#111");
			$("#responseAsDtIcon").css("color", "gray");
			$("#responseDsDtIcon").css("color", "#111");

			var val1;
			var val2;

			for (var i = 0; i < lstQuotes.length - 1; i++) {
				val1 = lstQuotes[i].responseOn;
				for (var j = i + 1; j < lstQuotes.length; j++) {
					val2 = lstQuotes[j].responseOn;
					if (val1 > val2) {
						var tmp = lstQuotes[j];
						lstQuotes[j] = lstQuotes[i];
						lstQuotes[i] = tmp;
						val1 = lstQuotes[i].responseOn;
					}
				}
			}
			this.setQuotesTable();
		}
	}

	sortDesByResponse = () => {
		if (sortVal != 'dsres') {
			sortVal = 'dsres';
			$("#recievedAsDtIcon").css("color", "#111");
			$("#recievedDsDtIcon").css("color", "#111");
			$("#responseAsDtIcon").css("color", "#111");
			$("#responseDsDtIcon").css("color", "gray");

			var val1;
			var val2;

			for (var i = 0; i < lstQuotes.length - 1; i++) {
				val1 = lstQuotes[i].responseOn;
				for (var j = i + 1; j < lstQuotes.length; j++) {
					val2 = lstQuotes[j].responseOn;
					if (val1 < val2) {
						var tmp = lstQuotes[j];
						lstQuotes[j] = lstQuotes[i];
						lstQuotes[i] = tmp;
						val1 = lstQuotes[i].responseOn;
					}
				}
			}
			this.setQuotesTable();
		}
	}

	render() {
		httpURL = window.httpURL;
		return (
			<div style={{ height: '100%' }}>
				<WeaverHeader />
				<ToastContainer autoClose={2000} hideProgressBar />
				<div className="main">
					<div className="container-fluid">
						<div className="col-sm-12 col-centered">
							<div className="col-sm-12 padding-remove" style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: 10 }}>
								<label htmlFor="inp_fromDate">From Date</label>
								<div style={{ marginLeft: 5, width: 100 }}>
									<DatePicker id="inp_fromDate"
										className='form-control text-center'
										placeholderText="From Date"
										selected={this.state.startDate}
										dateFormat="dd-MM-yyyy"
										autoComplete='off'
										onChange={(date) => { this.setState({ startDate: date }) }}
									/>
								</div>
								<label style={{ marginLeft: 10 }} htmlFor="inp_toDate">To Date</label>
								<div style={{ marginLeft: 5, width: 100 }}>
									<DatePicker id="inp_toDate"
										className='form-control text-center'
										placeholderText="To Date"
										selected={this.state.endDate}
										dateFormat="dd-MM-yyyy"
										autoComplete='off'
										onChange={(date) => { this.setState({ endDate: date }) }}
									/>
								</div>
								<button style={{ marginLeft: 20 }} type="button" id="getData" className="btn btn-warning" onClick={this.getQuote}>Get Data</button>
							</div>
							<div className="col-sm-12 padding-remove">
								<table className="tableLayout1" style={{ width: this.state.width }}>
									<thead>
										<tr>
											<th style={{ width: 30 }}>Quote Id</th>
											<th style={{ width: 30 }}>Design Id</th>
											<th style={{ width: 50 }}>
												<input type="text" onChange={this.setQuotesTable} className="form-control inp-search" id="filterDesignColor" placeholder="Design Color" />
											</th>
											<th style={{ width: 50 }}>
												<div style={{ float: 'left', marginLeft: '25%' }}>Recieved On</div>
												<div style={{ width: 10, float: 'left', marginLeft: 2, marginTop: -4 }}>
													<div className="assending">
														<span id="recievedAsDtIcon" onClick={this.sortAscByRecieved} className="glyphicon glyphicon-triangle-top"></span>
													</div>
													<div className="desending">
														<span id="recievedDsDtIcon" onClick={this.sortDesByRecieved} className="glyphicon glyphicon-triangle-bottom"></span>
													</div>
												</div>
											</th>
											<th style={{ width: 50 }}>
												<div style={{ float: 'left', marginLeft: '25%' }}>Response On</div>
												<div style={{ width: 10, float: 'left', marginLeft: 2, marginTop: -4 }}>
													<div className="assending">
														<span id="responseAsDtIcon" onClick={this.sortAscByResponse} className="glyphicon glyphicon-triangle-top"></span>
													</div>
													<div className="desending">
														<span id="responseDsDtIcon" onClick={this.sortDesByResponse} className="glyphicon glyphicon-triangle-bottom"></span>
													</div>
												</div>
											</th>
											<th style={{ width: 30 }}>Status</th>
										</tr>
									</thead>
								</table>
								<div className="col-sm-12 quoteTableDiv padding-remove">
									<table id="quoteTable" className="tableLayout">
										<colgroup>
											<col width="30" />
											<col width="30" />
											<col width="50" />
											<col width="50" />
											<col width="50" />
											<col width="30" />
										</colgroup>
										<tbody id="quoteTableBody"></tbody>
									</table>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="designPopup1">
					<header style={{ width: '90%' }}>
						<label style={{ marginLeft: 15 }} htmlFor="inp_quoteId">Quote Id:</label>
						<input readOnly style={{ marginLeft: 15, width: 100, height: 35, border: '1px solid #ccc', borderRadius: 6, padding: 5 }} type="text" className="inp-search text-right" id="inp_quoteId" placeholder="Quote ID" />
						<a href="#0" className="cd-panel-close glyphicon glyphicon-remove" onClick={this.hideSlider}>Close</a>
					</header>

					<div style={{ width: '90%' }}>
						<div className="cd-panel-content" style={{ padding: '70px 0% 20px' }}>
							<div className="col-sm-12">
								<table className="tableLayout2" style={{ width: this.state.width1 }}>
									<thead style={{ height: 12 }}>
										<tr>
											<th style={{ width: 50 }}>Design Id</th>
											<th style={{ width: 50 }}>Design Color</th>
											<th style={{ width: 50 }}>Image</th>
											<th style={{ width: 50 }}>Recieved On</th>
											<th style={{ width: 50 }}>Response On</th>
											<th style={{ width: 50 }}>Status</th>
											<th style={{ width: 50 }}>Construction</th>
											<th style={{ width: 50 }}>Yarn Count</th>
											<th style={{ width: 50 }}>Quality</th>
											<th style={{ width: 50 }}>Length</th>
											<th style={{ width: 50 }}>Width</th>
										</tr>
									</thead>
								</table>
								<div className="col-sm-12 quoteDesignTableDiv1 padding-remove">
									<table id="quoteDesignTable" className="tableLayout">
										<colgroup>
											<col width="50" />
											<col width="50" />
											<col width="50" />
											<col width="50" />
											<col width="50" />
											<col width="50" />
											<col width="50" />
											<col width="50" />
											<col width="50" />
											<col width="50" />
											<col width="50" />
										</colgroup>
										<tbody id="quoteDesignTableBody"></tbody>
									</table>
								</div>
							</div>

							<div style={{ marginTop: 10 }}>
								<div className="col-sm-9">
									<form id="wvrQuoteDesignForm" className="form-horizontal">
										<div className="row">
											<div className="col-sm-8">
												<div className="row">
													<div className="form-group col-sm-6">
														<label className="control-label col-sm-7">Machine Type:<span style={{ color: 'red' }}>*</span></label>
														<div className="col-sm-5 padding-remove">
															<select style={{ width: '100%' }} className="select-box" id="inp_machineCmb"></select>
														</div>
													</div>
													<div className="form-group col-sm-6">
														<label htmlFor="inp_construction" className="control-label col-sm-7 ">Construction:<span style={{ color: 'red' }}>*</span></label>
														<div className="col-sm-5 padding-remove">
															<select style={{ width: '100%' }} className="select-box" id="inp_construction" />
														</div>
													</div>
												</div>
												<div className="row">
													<div className="form-group col-sm-6">
														<label htmlFor="inp_width" className="control-label col-sm-7">Width:</label>
														<div className="col-sm-5 padding-remove">
															<select style={{ width: '100%' }} className="select-box" id="inp_width" />
														</div>
													</div>
													<div className="form-group col-sm-6">
														<label htmlFor="inp_quality" className="control-label col-sm-7">Quality:<span style={{ color: 'red' }}>*</span></label>
														<div className="col-sm-5 padding-remove">
															<select style={{ width: '100%' }} className="select-box" id="inp_quality" />
														</div>
													</div>
												</div>
												<div style={{ color: 'red', fontSize: 10, paddingLeft: 15 }}>Note: Rate is mandatory, if MOQ and MOR are not entered.</div>
												<div className="row">
													<div className="form-group col-sm-6">
														<label htmlFor="inp_yarnCount" className="control-label col-sm-7">Yarn Count:<span style={{ color: 'red' }}>*</span></label>
														<div className="col-sm-5 padding-remove">
															<select style={{ width: '100%' }} className="select-box" id="inp_yarnCount" />
														</div>
													</div>
													<div className="form-group col-sm-6">
														<label htmlFor="inp_rate" className="control-label col-sm-7">Rate:<span style={{ color: 'red' }}>*</span></label>
														<div className="col-sm-5 padding-remove">
															<input type="text" className="form-control" placeholder="Rate" id="inp_rate" />
														</div>
													</div>
												</div>
												<div className="row">
													<div className="form-group col-sm-6">
														<label htmlFor="inp_moq" className="control-label col-sm-7">MOQ:<span style={{ color: 'red' }}>*</span></label>
														<div className="col-sm-5 padding-remove">
															<input type="text" className="form-control" placeholder="MOQ" id="inp_moq" />
														</div>
													</div>
													<div className="form-group col-sm-6">
														<label htmlFor="inp_mor" className="control-label col-sm-7">MOR:<span style={{ color: 'red' }}>*</span></label>
														<div className="col-sm-5 padding-remove">
															<input type="text" className="form-control" placeholder="MOR" id="inp_mor" />
														</div>
													</div>
												</div>
											</div>
											<div className="col-sm-4">
												<div className="form-group col-sm-12">
													<label htmlFor="inp_notes" className="col-sm-12 padding-remove">Notes:</label>
													<div className="col-sm-12 padding-remove">
														<textarea readOnly rows="5" style={{ resize: "none" }} placeholder="Notes" className="form-control" id="inp_notes"></textarea>
													</div>
												</div>
											</div>
										</div>
									</form>
								</div>
								<div className="col-sm-3">
									<div id="quoteDesignImageDiv">
										<ReactImageMagnify {...{
											smallImage: {
												alt: 'Design Image',
												src: this.state.src,
												isFluidWidth: true,
											},
											largeImage: {
												src: this.state.src,
												width: 600,
												height: 900
											},
											enlargedImageContainerDimensions: {
												width: 300,
												height: 300,
											},
											enlargedImageContainerStyle: {
												left: -310,
												top: -85,
											},
										}} />
									</div>
								</div>
							</div>
							<div className="col-sm-12 text-center" style={{ marginTop: 10 }}>
								<button type="button" onClick={this.update} className="btn btn-warning" id="update_po">Update</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default Weaver;
